import React, { useState } from "react";
import { GraduationCap, HeartHandshake, BadgeCheck } from "lucide-react";
import { toast } from "sonner";
import api, { formatErr } from "../../lib/api";
import TurnstileField, { TS_KEY } from "../../components/TurnstileField";

export default function Careers() {
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "" });
  const [tsToken, setTsToken] = useState(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (TS_KEY && !tsToken) { toast.error("Please complete the security check."); return; }
    setBusy(true);
    try {
      await api.post("/public/careers", { ...form, turnstile_token: tsToken });
      toast.success("Application received! Our team will contact you about training and roles.");
      setForm({ name: "", phone: "", email: "", message: "" });
    } catch (err) { toast.error(formatErr(err)); }
    setBusy(false);
  };
  return (
    <div className="p1-container py-14 lg:py-20" data-testid="careers-page">
      <div className="grid gap-10 lg:grid-cols-2">
        <div>
          <p className="p1-eyebrow">Careers & Training</p>
          <h1 className="mt-3 font-heading text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl">Do the most meaningful work in Jaipur.</h1>
          <p className="mt-4 text-lg text-stone-600">Join ParentOne as a Care Manager or caregiver — or train with us to build a career in professional elder care.</p>
          <div className="mt-8 space-y-5">
            {[
              { icon: HeartHandshake, t: "Care Manager roles", s: "Own a small set of families. Coordinate their care, build real relationships, be someone's trusted person." },
              { icon: GraduationCap, t: "Caregiver training programme", s: "Structured training in elder care, first aid, communication and dignity — with certification on completion." },
              { icon: BadgeCheck, t: "Verified professional identity", s: "Background verification, fair pay, and a professional record you carry forward." },
            ].map((r) => (
              <div key={r.t} className="flex items-start gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-emerald-900/5 text-emerald-900"><r.icon className="h-5 w-5" /></span>
                <div><p className="font-heading font-semibold text-stone-900">{r.t}</p><p className="text-sm text-stone-600">{r.s}</p></div>
              </div>
            ))}
          </div>
        </div>
        <form onSubmit={submit} className="p1-card h-fit p-7" data-testid="careers-form">
          <h2 className="font-heading text-xl font-bold text-stone-900">Apply / Register interest</h2>
          <div className="mt-5 space-y-4">
            <div><label className="p1-label">Full name *</label>
              <input className="p1-input" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="careers-name" /></div>
            <div><label className="p1-label">Phone *</label>
              <input className="p1-input" required value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="careers-phone" /></div>
            <div><label className="p1-label">Email</label>
              <input type="email" className="p1-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="careers-email" /></div>
            <div><label className="p1-label">I'm interested in</label>
              <textarea className="p1-input" rows={3} placeholder="e.g. Care Manager role, caregiver training, nursing…" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="careers-interest" /></div>
            <TurnstileField onToken={setTsToken} />
            <button type="submit" disabled={busy} className="p1-btn-primary w-full" data-testid="careers-submit">{busy ? "Submitting…" : "Submit Application"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
